import { SubjectCodes, usePrintableWorksheetsState } from 'printableWorksheets/state'
import React from 'react'
import './styles.scss'


const SubjectSelector = () => {

  const subjectCodeToTitleMapper: any = {
    [SubjectCodes.MATH]: 'Math',
    [SubjectCodes.ELA]: 'English',
  }

  const { subjectCode, setSubjectCode} = usePrintableWorksheetsState();
  return (
    <div className='grade-selector'>
      <span className='heading'> Subject</span>
      <div className='grades-container subject-selector'>
        { Object.keys(SubjectCodes).map((subject)=> {
            return <div key={subject} onClick={()=>setSubjectCode(SubjectCodes[subject])} className={`grade ${SubjectCodes[subject] == subjectCode ? 'selected' : ''}`} >{subjectCodeToTitleMapper[SubjectCodes[subject]]}</div>
            })
        }
      </div>
    </div>
  )
}

export default SubjectSelector